import React, { useState, useRef } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import JsBarcode from "jsbarcode";
import Header from './Header';
import Footer from './Footer';

const BarcodeGenerator = () => {
  const [barcodeText, setBarcodeText] = useState("");
  const barcodeRef = useRef(null);
  const [showDownload, setShowDownload] = useState(false);

  const generateBarcode = (e) => {
    e.preventDefault();
    if (!barcodeText) return;

    JsBarcode(barcodeRef.current, barcodeText, {
      format: "CODE128",
      width: 2,
      height: 50,
      displayValue: true,
    });
    setShowDownload(true);
  };

  const downloadBarcode = () => {
    const svgData = new XMLSerializer().serializeToString(barcodeRef.current);
    const blob = new Blob([svgData], { type: "image/svg+xml;charset=utf-8" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = `${barcodeText}_barcode.svg`;
    a.click();
    URL.revokeObjectURL(url);
  };

  return (
    <>
    <Header />
    <Container fluid className="py-5">
      <Row className="justify-content-center">
        <Col sm={8} className="text-center p-4 bg-white shadow">
          <h1>Barcode Generator Tool</h1>
          <p className="mt-4">
            Unlock the power of effortless barcode creation with our Free Barcode Generator. Whether you need a quick barcode for inventory management, product labeling, or any other application, our intuitive barcode tool for free ensures you get the job done swiftly and accurately. Generate high-quality barcodes in seconds with our user-friendly interface—no cost, no hassle. Experience the convenience of a quick barcode solution that meets all your business needs without the need for expensive software. Try it now and streamline your barcode generation process effortlessly!
          </p>
          <Form onSubmit={generateBarcode} className="mt-3">
            <Form.Group>
              <Form.Label>Enter Text for Barcode:</Form.Label>
              <Form.Control
                type="text"
                value={barcodeText}
                onChange={(e) => setBarcodeText(e.target.value)}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="mt-3">
              Generate Barcode
            </Button>
          </Form>
          <div className="mt-4">
            <svg ref={barcodeRef}></svg>
          </div>
          {showDownload && (
            <Button
              variant="warning"
              className="mt-3"
              onClick={downloadBarcode}
            >
              Download Barcode
            </Button>
          )}
        </Col>
      </Row>
    </Container>
    <Footer />
    </>
  );
};

export default BarcodeGenerator;